import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceQrPairPayload } from 'api/actions/device-qr-pair/device-qr-pair-payload';
import { DeviceQrPairPathParameters } from 'api/actions/device-qr-pair/device-qr-pair-path-parameters';
import { DeviceQrPairResponse } from 'api/actions/device-qr-pair/device-qr-pair-response';

type DeviceQrPairQueryParameters = Record<string, any>;

/**
 * The path of the DeviceQrPair action.
 */
export const deviceQrPairActionPath = new SweetPath<keyof DeviceQrPairPathParameters>('/api/device/qr/{deviceId}', {
  path: '{param}',
});

/**
 * Creates a contextualized DeviceQrPair actions.
 */
export default function createDeviceQrPairAction(axios: AxiosInstance) {
  return function deviceQrPairAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceQrPairPathParameters;
    query?: DeviceQrPairQueryParameters;
    payload: DeviceQrPairPayload;
  }) {
    const path = deviceQrPairActionPath.insert(parameters);

    return axios.request<DeviceQrPairResponse, DeviceQrPairResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
